'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.13.2@antd/lib/spin/style/css.js
// module id = 1024
// module chunks = 0